import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { UserService } from '../services/user.service';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard implements CanActivate {
  constructor(private auth: AuthService, private userService: UserService, private router: Router) {}

  canActivate(): boolean | UrlTree | any {
    const token = this.auth.token;
    if (!token) {
      return true;
    }
    if (this.userService.currentUser) {
      return this.router.parseUrl('/app/home');
    }
    return this.userService.loadMe().pipe(
      map(() => this.router.parseUrl('/app/home')),
      catchError(() => {
        this.auth.logout();
        this.userService.setUser(null);
        return of(true);
      })
    );
  }
}
